const item1s = [
  {
    title: "部署灵活速度快",
    content:
      "即插即用，极简配置，可快速接入全球加速网络，支持配合业务灵活调整，迁移无忧",
    img: "/imgs/kwan/advantage/1.png",
  },
  {
    title: "支持多场景加速",
    content: "自研K-WAN组网解决方案，配合管理系统调配，可适配更多的应用场景",
    img: "/imgs/kwan/advantage/2.png",
  },
  {
    title: "成本可控性价比高",
    content: "按需付费即开即用，可随时进行带宽调整，应对不同业务场景，降低成本",
    img: "/imgs/kwan/advantage/3.png",
  },
];

const item2s = [
  {
    title: "企业专用管理系统",
    content:
      "提供企业后台管理系统，可以根据公司架构针对部门分类管理，线路调度分配、IP定制、数据监控等",
    img: "/imgs/kwan/advantage/4.png",
  },
  {
    title: "安全稳定合规",
    content: "加密传输协议，保证数据安全，所有专线均来自合规运营商",
    img: "/imgs/kwan/advantage/5.png",
  },
  {
    title: "专业售后快速响应",
    content:
      "专业售后团队，7*24小时在线支持，随时响应解决问题，为您的业务保驾护航",
    img: "/imgs/kwan/advantage/6.png",
  },
];

export const Advantages = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#021360] to-[#01112D]">
      <div className="w-[1920px] px-[150px] pb-[105px]  pt-[60px]">
        <div className="text-[#fff] text-center font-['Alibaba_PuHuiTi_3.0'] text-[45px] font-bold leading-[120%] tracking-[4.5px]">
          我们的优势
        </div>
        <div className="flex gap-[40px] justify-between mt-[80px]">
          {item1s.map((item) => (
            <Item key={item.title} title={item.title} content={item.content} img={item.img} />
          ))}
        </div>
        <div className="flex gap-[40px] justify-between mt-[70px]">
          {item2s.map((item) => (
            <Item key={item.title} title={item.title} content={item.content} img={item.img} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const Item = (props: {
  title: string;
  content: string;
  img: string;
}) => {
  return (
    <div className="flex flex-col items-center max-w-[350px]">
      <div className="w-[166px] h-[166px]  rounded-[10px]">
        <img src={props.img} className="w-[100%] h-[100%]" />
      </div>
      <div className="font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-bold text-[28px] text-[#FFFFFF] text-center mt-[20px]">
        {props.title}
      </div>
      <div className="font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-Regular text-[18px] text-[#FFFFFF] text-center mt-[18px]">
        {props.content}
      </div>
    </div>
  );
};
